import { mergeData } from 'utils/data'

import {
  CLEAR_AGED_DEBT_CHILDREN,
  LIST_AGED_DEBT_CHILDREN,
  LIST_AGED_DEBT_CHILDREN_FAILED,
  LIST_AGED_DEBT_CHILDREN_SUCCESS,
} from './constants'

const initialState = {
  data: null,
  error: null,
  isFetching: false,
  meta: {
    // eslint-disable-next-line camelcase
    total_results: null,
  },
}

export default (state = initialState, { error, mergeResult, payload, type }) => {
  switch (type) {
    case LIST_AGED_DEBT_CHILDREN:
      return { ...state, error: initialState.error, isFetching: true }
    case LIST_AGED_DEBT_CHILDREN_SUCCESS:
      return {
        ...state,
        data: mergeData(state.data, payload.data, mergeResult),
        isFetching: false,
        meta: payload.meta,
      }
    case LIST_AGED_DEBT_CHILDREN_FAILED:
      return { ...state, error, isFetching: false }
    case CLEAR_AGED_DEBT_CHILDREN:
      return initialState
    default:
      return state
  }
}
